import { RoleService } from "@js/services/RoleService";
import { FeedBack, FeedBackClient, Organisation } from "@src/apis/ModularClient";

export class FeedBackController {
  static $inject = ["$rootScope", "$routeParams", "$location", "FeedBackClient", "RoleService"];

  feedBackDTO: FeedBack;
  organisation: Organisation;
  fullAvatarUrl: string = "";
  showReplySection: boolean = false;
  dataLoading: boolean = false;
  isDeal: boolean = true;
  reviewerFullName: string;
  reviewerOrganisationName: string;
  reviewerOrganisationUrl: string;
  reviewerProfileUrl: string;
  reviewerInitial: string;
  responseUserOrgName: string;
  dealName: string;
  isLender: boolean;
  constructor(
    private $rootScope: ng.IRootScopeService,
    private $routeParams: ng.route.IRouteParamsService,
    private $location: ng.ILocationService,
    private feedBackClient: FeedBackClient,
    private roleService: RoleService,
  ) {
    if (this.$location.path().startsWith("/casefeedback")) {
      this.isDeal = false;
    }

    this.init();
  }

  private async init() {
    const response = await this.feedBackClient.getFeedBackAndReviewerDetails({
      feedBackId: Number(this.$routeParams.FeedBackId),
      dealLeanderId: Number(this.$routeParams.DealLenderId),
      isDeal: this.isDeal,
    });

    this.feedBackDTO = response.feedBackDTO;
    this.reviewerFullName = response.reviewerFullName;
    this.reviewerOrganisationName = response.reviewerOrganisationName;
    this.reviewerOrganisationUrl = response.reviewerOrganisationUrl;
    this.reviewerProfileUrl = response.reviewerProfileUrl;
    this.reviewerInitial = response.reviewerInitial;
    this.responseUserOrgName = response.responseUserOrgName;
    this.dealName = response.dealName;
    await this.checkingIfUserIsLender();
  }

  async checkingIfUserIsLender(): Promise<void> {
    this.isLender = await this.roleService.isLenderUser();
  }

  submitReplyToFeedBack() {
    this.dataLoading = true;
    this.feedBackClient
      .sendFeedBackReply(Number(this.$routeParams.DealLenderId), this.isDeal, this.feedBackDTO)
      .then((response) => {
        this.$location.path("/userdashboard");
      })
      .finally(() => {
        this.dataLoading = false;
      });
  }

  /** Redirects to the user dashboard */
  goToUserDashboard() {
    this.$location.path("/userdashboard");
  }
}
